/* eslint-disable no-useless-escape */
import Box from '@material-ui/core/Box'
import { Theme } from '@material-ui/core/styles/createTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import PlayArrow from '@material-ui/icons/PlayArrow'
import React, { useContext, useEffect, useState } from 'react'

import colorContext from '../../../../Context/colorContext'

interface VideoProps {
  resumo: string
  titulo: string
  video_id: string
}
interface Props {
  videoList: VideoProps[]
}

export default function Videos({ videoList }: Props): JSX.Element {
  const matches = useMediaQuery('(max-width:1032px)')
  const [videoId, setVideoId] = useState<string>(videoList[0].video_id)
  const { colors } = useContext(colorContext)
  const [isShowIframe, setIsShowIframe] = useState(false)
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '49px 5px',
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 5,
      fontWeight: 'bold',
      color: colors.textBody,
      fontSize: theme.typography.pxToRem(36),
      left: 8,
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        marginBottom: 33,
        '&::after': {
          bottom: 4,
        },
      },
    },
    videoList: {
      marginTop: matches ? '10px' : '0px',
      marginLeft: 14,
      maxWidth: matches ? 'none' : '300px',
      [theme.breakpoints.down('md')]: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
      [theme.breakpoints.down('xs')]: {
        display: 'block',
      },
    },
    videoItem: {
      width: '100%',
      display: 'flex',
      color: colors.textBody,
      marginBottom: 13,
      cursor: 'pointer',
      justifyContent: 'center',
    },
    videoItemSelected: {
      width: '100%',
      minWidth: 371,
      minHeight: 210,
      height: 'auto',
      display: 'flex',
      marginBottom: 13,
      alignItems: 'center',
    },
    videoPreview: {
      width: '100%',
      maxWidth: 279.99,
      height: 210,
      marginRight: 10,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    },
    iconBoxMain: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    titleVideo: {
      fontFamily: 'Roboto',
      fontSize: 16,
      fontWeight: 600,
      color: colors.textBody,
      maxWidth: 275,
    },
    boxIconPlay: {
      backgroundColor: 'rgba(255, 255, 255, 0.24)',
      border: '0.5px solid rgba(255, 255, 255, 0.8)',
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    icon: {
      fontSize: 20,
      color: colors.textAccentColor,
      zIndex: 5,
    },
    img: {
      borderRadius: 15,
    },
    button: {
      maxWidth: 360,
      width: '100%',
      marginTop: 80,
      height: 42,
      borderRadius: 25,
      backgroundColor: colors.colorWithoutGradient,
      alignSelf: 'center',
      color: colors.accentColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textDecoration: 'none',
      marginRight: 8,
      marginLeft: 8,
      textTransform: 'uppercase',
      '&:hover': {
        backgroundColor: colors.colorWithoutGradient,
      },
    },
    textList: {
      marginRight: 8,
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 700,
      marginLeft: 8,
      textTransform: 'uppercase',
      color: colors.accentColor,
      '&:hover': {
        color: colors.textAccentColor,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
    box: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
      },
    },
    thumbnail: {
      width: '100%',
      height: '433px',
    },
  }))
  const classes = useStyles()

  function handleClickInVideo() {
    setIsShowIframe(true)
  }

  const currentVideo = videoList.find((v) => v.video_id === videoId)

  const renderVideoMain = () => (
    <Box
      style={{
        height: 433,
        width: '100%',
        maxWidth: matches ? 'none' : 900,
      }}
    >
      {isShowIframe ? (
        <iframe
          style={{
            width: '100%',
            padding: 10,
            backgroundColor: colors.colorCarousel,
            borderRadius: 15,
          }}
          width="100%"
          height="433px"
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          frameBorder="0"
          allow="fullscreen;accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      ) : (
        <button
          type="button"
          onClick={handleClickInVideo}
          className={classes.thumbnail}
          aria-label={`Reproduzir vídeo: ${currentVideo?.titulo ?? 'vídeo'}`}
        >
          <img
            src={`https://img.youtube.com/vi_webp/${videoId}/0.webp`}
            width="100%"
            height="433px"
            alt=""
            loading="lazy"
          />
        </button>
      )}
    </Box>
  )

  useEffect(
    () => () => {
      renderVideoMain()
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [videoId],
  )
  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.box}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            Vídeos
          </Typography>
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          {renderVideoMain()}
          <Box className={classes.videoList}>
            {videoList.slice(0, 2).map((video) => (
              <Box
                key={video?.video_id?.toString()}
                className={classes.videoItem}
                onClick={() => {
                  setVideoId(video.video_id)
                  setIsShowIframe(false)
                }}
              >
                <Box className={classes.videoPreview}>
                  <img
                    src={`https://img.youtube.com/vi_webp/${video.video_id}/0.webp`}
                    width="100%"
                    height="210px"
                    alt={`Miniatura do vídeo: ${video.titulo}`}
                    className={classes.img}
                    loading="lazy"
                  />
                  <div className={classes.iconBoxMain}>
                    <Box className={classes.boxIconPlay}>
                      <PlayArrow className={classes.icon} />
                    </Box>
                  </div>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
        <a href="/videos" className={classes.button} rel="noreferrer">
          <p className={classes.textList}>VEJA TODOS OS VÍDEOS</p>
        </a>
      </Box>
    </Box>
  )
}
